import { createFormAction } from 'redux-form-saga';

export const requestEmailConfirmation = createFormAction('REQUEST_EMAIL_CONFIRMATION');
